module.exports = __webpack_public_path__ + "static/media/ic_proyectos_multimodal_pin.191fd665.svg";